import { environment } from 'src/config/environment';

export const buildPublicUrlLink = (path: string) =>
  `${environment.publicUrl}/${path}`;
